import { isProduction, isStaging, isAwsDev } from '@upright/common/environment';
import { Helmet } from 'react-helmet';

interface Props {
  url: CookieYesUrl;
}

export const CookieConsent = (props: Props) => {
  if (isProduction() || isStaging() || isAwsDev()) {
    return (
      <Helmet>
        <script id="cookieyes" type="text/javascript" src={props.url} />
      </Helmet>
    );
  }
  return null;
};

export enum CookieYesUrl {
  PLATFORM = 'https://cdn-cookieyes.com/client_data/db5d1855d466378fb1af685f/script.js',
  // TODO can this be removed?
  FACADE = 'https://cdn-cookieyes.com/client_data/d261f3e109d46d85626a21d9/script.js',
  DEVELOPMENT = 'https://cdn-cookieyes.com/client_data/9dc957535eb0a131cbc8fe10/script.js',
}
